import { reportScheduleConstants } from '../constants/reportSchedule.constants';
import reportScheduleService from '../services/reportSchedule.service';
import { alertActions } from './alert.actions';
import { history } from '../helpers';

export const reportScheduleActions = {
  create,
  update,
  remove,
  fetch,
  get,
  run,
};

function create(obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const schedule = await reportScheduleService.create(obj);
      dispatch(success(schedule));
      dispatch(alertActions.success("Agendamento criado"));
      history.push('/report-schedule');
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportScheduleConstants.CREATE_REQUEST } }
  function success(schedule) { return { type: reportScheduleConstants.CREATE_SUCCESS, schedule } }
  function failure(error) { return { type: reportScheduleConstants.CREATE_FAILURE, error } }
}

function update(id, obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const schedule = await reportScheduleService.update(id, obj);
      dispatch(success(schedule));
      dispatch(alertActions.success("Agendamento alterado"));
      history.push('/report-schedule');
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportScheduleConstants.UPDATE_REQUEST } }
  function success(schedule) { return { type: reportScheduleConstants.UPDATE_SUCCESS, schedule } }
  function failure(error) { return { type: reportScheduleConstants.UPDATE_FAILURE, error } }
}

function remove(id) {
  return async dispatch => {
    dispatch(request());
    try {
      await reportScheduleService.remove(id);
      dispatch(success(true));
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportScheduleConstants.REMOVE_REQUEST } }
  function success(result) { return { type: reportScheduleConstants.REMOVE_SUCCESS, result } }
  function failure(error) { return { type: reportScheduleConstants.REMOVE_FAILURE, error } }
}

function fetch(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const schedules = await reportScheduleService.fetch(params);
      dispatch(success(schedules));
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportScheduleConstants.FETCH_REQUEST } }
  function success(schedules) { return { type: reportScheduleConstants.FETCH_SUCCESS, schedules } }
  function failure(error) { return { type: reportScheduleConstants.FETCH_FAILURE, error } }
}

function get(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const schedule = await reportScheduleService.get(id);
      dispatch(success(schedule));
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportScheduleConstants.GET_REQUEST } }
  function success(schedule) { return { type: reportScheduleConstants.GET_SUCCESS, schedule } }
  function failure(error) { return { type: reportScheduleConstants.GET_FAILURE, error } }
}

function run(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const result = await reportScheduleService.run(id);
      dispatch(success(result));
      dispatch(alertActions.success("Envio do relatório enfileirado"));
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: reportScheduleConstants.RUN_REQUEST } }
  function success(result) { return { type: reportScheduleConstants.RUN_SUCCESS, result } }
  function failure(error) { return { type: reportScheduleConstants.RUN_FAILURE, error } }
}
